import Event from "./sections/event";
import Food from "./sections/food";
import Beverages from "./sections/beverages";
import Service from "./sections/service";
import Rentals from "./sections/rentals";
import Staff from "./sections/staff";
import {CountUp} from "countup.js";


class Calculator {

  constructor(form) {
    this.version = '2.0';

    this.form = form

    this.event = new Event(this)

    //Pull in calculation modules
    this.food = new Food(this)
    this.beverages = new Beverages(this)
    this.service = new Service(this)
    this.rentals = new Rentals(this)
    this.staff = new Staff(this)

    const easingFn = function (t, b, c, d) {
      var ts = (t /= d) * t;
      var tc = ts * t;
      return b + c * (tc + -3 * ts + 3 * t);
    }
    const options = {
      easingFn,
      prefix: '$',
    };


    this.estimate = new CountUp('calcEstimate', 0, options);

    if (!this.estimate.error) {
      this.estimate.start();
    } else {
      console.error(this.estimate.error);
    }

    this.form.on('catcalc.change', () => {
      this.updateSummary();
    })

  }

  format(cost) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(cost)
  }

  fees() {
    let fees = (this.food.fees() + this.beverages.fees() + this.service.fees() + this.rentals.fees());
    this.form.find('.catcalc-summary-fees-cost input').val(this.format(fees));
    return fees;
  }

  total() {
    let total = (this.food.total() + this.beverages.total() + this.service.total() + this.rentals.total() + this.staff.total());
    this.form.find('.catcalc-summary-total input').val(this.format(total));
    return total;
  }

  updateSummary() {

    let summary = $('.catcalc--summary');

    // this.estimate.update(this.total());

    $('#calcEstimate').html(this.format(this.total()));

    // summary.find('.catcalc--summary-food').html(this.food.total())
    // summary.find('.catcalc--summary-beverages').html(this.beverages.total())
    // summary.find('.catcalc--summary-service').html(this.service.total())
    // summary.find('.catcalc--summary-rentals').html(this.rentals.total())
    summary.find('.catcalc--summary-staff').html("$" + this.staff.total())
    summary.find('.catcalc--summary-staff-servers .count').html(this.staff.serversQty());
    summary.find('.catcalc--summary-staff-bartenders .count').html(this.staff.bartendersQty());
    summary.find('.catcalc--summary-fees').html(this.format(this.fees()));
    summary.find('.catcalc--summary-total').html(this.format(this.total()));
  }

}

export default Calculator



// WEBPACK FOOTER //
// ./scripts/catcalc/calculator.js